import { DESIGN_SYSTEM_SIZES, LINK_FORMATS } from '@/constants/styles';
import { valueof } from '@/types';
import styles from './StyledLink.module.scss';

type LinkSize = valueof<typeof DESIGN_SYSTEM_SIZES>;

type LinkFormat = valueof<typeof LINK_FORMATS>;

type StyledLinkProps = {
	id?: string;
	href: string;
	label: string;
	isDisabled?: boolean;
	size?: LinkSize;
	format?: LinkFormat;
	isUnderlined?: boolean;
};

export const StyledLink = ({
	id,
	href,
	label,
	isDisabled = false,
	size = DESIGN_SYSTEM_SIZES.MEDIUM,
	format = LINK_FORMATS.PARAGRAPHE,
	isUnderlined = true,
}: StyledLinkProps) => {
	const className = [
		styles.link,
		styles[size],
		format && styles[format],
		isDisabled && styles.disabled,
		isUnderlined && styles.underlined,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<a id={id} href={isDisabled ? '' : href} className={className} data-test-id="styled-link">
			{label}
		</a>
	);
};

export default StyledLink;
